// src/hooks/usePaymentProcessing.ts
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { PaymentData, TimeState, CustomerDetails } from "../types/salon.types";
import api from "../../../../../features/auth/axiosConfig";

export const usePaymentProcessing = () => {
  const [customerAdd, setCustomerAdd] = useState(false);
  const [openProductList, setOpenProductList] = useState(false);
  const [openTipsList, setOpenTipsList] = useState(false);
  const [openPaymentDetails, setOpenPaymentDetails] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [tipsAmount, setTipsAmount] = useState<{ [key: string]: string }>({});
  const [receivedAmount, setReceivedAmount] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [byTips, setByTips] = useState(false);
  const [time, setTime] = useState<TimeState>({
    hours: "",
    minutes: "",
    seconds: "",
    day: "",
    month: "",
    year: ""
  });

  useEffect(() => {
    const currentDate = new Date();
    const year = String(currentDate.getFullYear());
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");
    
    setTime({ hours, minutes, seconds, day, month, year });
  }, []);

  useEffect(() => {
    const fetchTipsSetting = async () => {
      try {
        const res = await api.get("/app/v1/pos/properties");
        const tipsProperty = res.data.result.find((prop: any) => prop.property_name === "Tips");
        setByTips(tipsProperty?.property_value === true);
      } catch (error) {
        console.error("Tips error", error);
      }
    };
    
    fetchTipsSetting();
  }, []);

  const handlePaymentMethodSelect = (method: string) => {
    setPaymentMethod(method);
    if (method === "Buy on credit") {
      setReceivedAmount("0");
    }

    if (byTips) {
      setOpenTipsList(true);
    } else {
      setOpenPaymentDetails(true);
    }

    setOpenProductList(false);
  };

  const handleTipsChange = (staffId: string, value: string) => {
    setTipsAmount(prev => ({
      ...prev,
      [staffId]: value,
    }));
  };

  const calculateTipsTotal = () => {
    return Object.values(tipsAmount).reduce((total, tip) => {
      return total + (parseFloat(tip) || 0);
    }, 0);
  };

  const resetPaymentState = () => {
    setCustomerAdd(false);
    setOpenProductList(false);
    setOpenTipsList(false);
    setOpenPaymentDetails(false);
    setPaymentMethod("");
    setTipsAmount({});
    setReceivedAmount("");
    setCustomerName("");
    setCustomerPhone("");
    setSelectedCustomerId("");
    setIsProcessingPayment(false);
  };

  return {
    customerAdd,
    openProductList,
    openTipsList,
    openPaymentDetails,
    paymentMethod,
    tipsAmount,
    receivedAmount,
    customerName,
    customerPhone,
    selectedCustomerId,
    isProcessingPayment,
    setIsProcessingPayment,
    byTips,
    time,
    setCustomerAdd,
    setOpenProductList,
    setOpenTipsList,
    setOpenPaymentDetails,
    setPaymentMethod,
    setReceivedAmount,
    setCustomerName,
    setCustomerPhone,
    setSelectedCustomerId,
    handlePaymentMethodSelect,
    handleTipsChange,
    calculateTipsTotal,
    resetPaymentState
  };
};